import { registerRoute } from '../infra/router/routeRegistry'
import SearchPage from './SearchPage'
import HistoryPage from './HistoryPage'
import FavoritesPage from './FavoritesPage'
import WordDetailPage from './WordDetailPage'
import React from 'react'

registerRoute({
  path: '/',
  viewFactory: () => React.createElement(SearchPage)
})

registerRoute({
  path: '/history',
  viewFactory: () => React.createElement(HistoryPage)
})

registerRoute({
  path: '/favorites',
  viewFactory: () => React.createElement(FavoritesPage)
})

registerRoute({
  path: '/word/:word',
  viewFactory: () => React.createElement(WordDetailPage)
})
